export default __webpack_public_path__ + "static/media/allmand.e5263fdd.jpg";